<template>
    <b-modal size="lg" 
            v-model="isModal" 
            no-close-on-backdrop 
            no-close-on-esc
            hide-header
            hide-footer>
            <div class="modal-header">
                <h5 class="modal-title">문의내역 조회</h5>
                <button type="button" class="close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- 모달 내용 -->
                <b-row class="pt-sm-1">
                    <b-col sm="12">
                        <table class="table table-bordered oddBackground">
                            <tbody>
                                <tr>
                                    <td style="width:25%">문의종류</td>
                                    <td class="tl" style="width:75%;">{{ item.type_name }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">등록일</td>
                                    <td class="tl" style="width:75%;">{{ item.reg_date }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">제목</td>
                                    <td class="tl" style="width:75%;">{{ item.title }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">내용</td>
                                    <td class="tl" style="width:75%;">{{ item.contents }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>

                <b-row class="pt-sm-1">
                    <b-col sm="12">
                        <table class="table table-bordered oddBackground">
                            <tbody>
                                <tr>
                                    <td style="width:25%">답변 작성자</td>
                                    <td class="tl" style="width:75%;">{{ item.reply_reg_user }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">답변일</td>
                                    <td class="tl" style="width:75%;">{{ item.reply_date }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">답변내용</td>
                                    <td class="tl" style="width:75%;">{{ item.reply_contents }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" @click="closeModal">확인</button>
            </div>
    </b-modal>
</template>
<script>
import { EventBus } from "../../../../../event-bus";

export default {
    name: "userQnaDetailModal",
    props: {
        formModal: {
            type: Boolean,
        },
        item: {
            type: Object,
        }
    },
    data() {
        return {
            isModal: false,    
        }
    },
    mounted() {
        // console.log('>>>>>', this.item);
    },
    methods: {
        closeModal(){
            EventBus.$emit('callQnaCloseModal');
        },
    },
    watch: {
        formModal: function (value, oldValue) {
            // console.log('====', value, oldValue);
            this.isModal=  this.formModal;
        },
    },
}
</script>
<style lang="css" scoped>
.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
  text-align: center;
}
.theader{
  background:#dcdcdc;
  font-weight: 600;
}
.tl {
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/views/user/userDetail/component/tabs/qna/UserQnaDetailModal.vue